/**
 * Feature toggle changes related to product customizations on buy it again surface. For Buildathon
 */
export const PRODUCT_CUSTOMIZATIONS_BUILDATHON_240808 = 'PRODUCT_CUSTOMIZATIONS_BUILDATHON_240808';
